module.exports = __webpack_public_path__ + "static/perfektio-77e180a57786d9fd1625b7db39717e9d.svg";